// source: scenetree/protos/scene_tree_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var core_protos_paging_pb = require('../../core/protos/paging_pb.js');
goog.object.extend(proto, core_protos_paging_pb);
var core_protos_uuid_pb = require('../../core/protos/uuid_pb.js');
goog.object.extend(proto, core_protos_uuid_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var scenetree_protos_domain_pb = require('../../scenetree/protos/domain_pb.js');
goog.object.extend(proto, scenetree_protos_domain_pb);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    viewId: (f = msg.getViewId()) && core_protos_uuid_pb.Uuid.toObject(includeInstance, f),
    pager: (f = msg.getPager()) && core_protos_paging_pb.OffsetPager.toObject(includeInstance, f),
    additionalColumnKeysList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid;
      reader.readMessage(value,core_protos_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setViewId(value);
      break;
    case 2:
      var value = new core_protos_paging_pb.OffsetPager;
      reader.readMessage(value,core_protos_paging_pb.OffsetPager.deserializeBinaryFromReader);
      msg.setPager(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addAdditionalColumnKeys(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getViewId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
  f = message.getPager();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_paging_pb.OffsetPager.serializeBinaryToWriter
    );
  }
  f = message.getAdditionalColumnKeysList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid view_id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.prototype.getViewId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.prototype.setViewId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.prototype.clearViewId = function() {
  return this.setViewId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.prototype.hasViewId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional vertexvis.protobuf.core.OffsetPager pager = 2;
 * @return {?proto.vertexvis.protobuf.core.OffsetPager}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.prototype.getPager = function() {
  return /** @type{?proto.vertexvis.protobuf.core.OffsetPager} */ (
    jspb.Message.getWrapperField(this, core_protos_paging_pb.OffsetPager, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.OffsetPager|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.prototype.setPager = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.prototype.clearPager = function() {
  return this.setPager(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.prototype.hasPager = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string additional_column_keys = 3;
 * @return {!Array<string>}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.prototype.getAdditionalColumnKeysList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.prototype.setAdditionalColumnKeysList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.prototype.addAdditionalColumnKeys = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeRequest.prototype.clearAdditionalColumnKeysList = function() {
  return this.setAdditionalColumnKeysList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    scenetree_protos_domain_pb.Node.toObject, includeInstance),
    totalVisible: jspb.Message.getFieldWithDefault(msg, 2, 0),
    cursor: (f = msg.getCursor()) && core_protos_paging_pb.OffsetCursor.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new scenetree_protos_domain_pb.Node;
      reader.readMessage(value,scenetree_protos_domain_pb.Node.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalVisible(value);
      break;
    case 3:
      var value = new core_protos_paging_pb.OffsetCursor;
      reader.readMessage(value,core_protos_paging_pb.OffsetCursor.deserializeBinaryFromReader);
      msg.setCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      scenetree_protos_domain_pb.Node.serializeBinaryToWriter
    );
  }
  f = message.getTotalVisible();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCursor();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      core_protos_paging_pb.OffsetCursor.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Node items = 1;
 * @return {!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Node>}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Node>} */ (
    jspb.Message.getRepeatedWrapperField(this, scenetree_protos_domain_pb.Node, 1));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Node>} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vertexvis.protobuf.scenetree.v1alpha1.Node, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional uint32 total_visible = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.prototype.getTotalVisible = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.prototype.setTotalVisible = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional vertexvis.protobuf.core.OffsetCursor cursor = 3;
 * @return {?proto.vertexvis.protobuf.core.OffsetCursor}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.prototype.getCursor = function() {
  return /** @type{?proto.vertexvis.protobuf.core.OffsetCursor} */ (
    jspb.Message.getWrapperField(this, core_protos_paging_pb.OffsetCursor, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.OffsetCursor|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.prototype.setCursor = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.prototype.clearCursor = function() {
  return this.setCursor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetTreeResponse.prototype.hasCursor = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    viewId: (f = msg.getViewId()) && core_protos_uuid_pb.Uuid.toObject(includeInstance, f),
    nodeId: (f = msg.getNodeId()) && core_protos_uuid_pb.Uuid.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid;
      reader.readMessage(value,core_protos_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setViewId(value);
      break;
    case 2:
      var value = new core_protos_uuid_pb.Uuid;
      reader.readMessage(value,core_protos_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setNodeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getViewId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
  f = message.getNodeId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid view_id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.prototype.getViewId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.prototype.setViewId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.prototype.clearViewId = function() {
  return this.setViewId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.prototype.hasViewId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional vertexvis.protobuf.core.Uuid node_id = 2;
 * @return {?proto.vertexvis.protobuf.core.Uuid}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.prototype.getNodeId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.prototype.setNodeId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.prototype.clearNodeId = function() {
  return this.setNodeId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeRequest.prototype.hasNodeId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandNodeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    viewId: (f = msg.getViewId()) && core_protos_uuid_pb.Uuid.toObject(includeInstance, f),
    nodeId: (f = msg.getNodeId()) && core_protos_uuid_pb.Uuid.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid;
      reader.readMessage(value,core_protos_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setViewId(value);
      break;
    case 2:
      var value = new core_protos_uuid_pb.Uuid;
      reader.readMessage(value,core_protos_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setNodeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getViewId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
  f = message.getNodeId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid view_id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.prototype.getViewId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.prototype.setViewId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.prototype.clearViewId = function() {
  return this.setViewId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.prototype.hasViewId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional vertexvis.protobuf.core.Uuid node_id = 2;
 * @return {?proto.vertexvis.protobuf.core.Uuid}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.prototype.getNodeId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.prototype.setNodeId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.prototype.clearNodeId = function() {
  return this.setNodeId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeRequest.prototype.hasNodeId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseNodeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    viewId: (f = msg.getViewId()) && core_protos_uuid_pb.Uuid.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid;
      reader.readMessage(value,core_protos_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setViewId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getViewId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid view_id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest.prototype.getViewId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest.prototype.setViewId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest.prototype.clearViewId = function() {
  return this.setViewId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeRequest.prototype.hasViewId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    change: (f = msg.getChange()) && scenetree_protos_domain_pb.TreeChangeType.toObject(includeInstance, f),
    handshake: (f = msg.getHandshake()) && proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new scenetree_protos_domain_pb.TreeChangeType;
      reader.readMessage(value,scenetree_protos_domain_pb.TreeChangeType.deserializeBinaryFromReader);
      msg.setChange(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake;
      reader.readMessage(value,proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake.deserializeBinaryFromReader);
      msg.setHandshake(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChange();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      scenetree_protos_domain_pb.TreeChangeType.serializeBinaryToWriter
    );
  }
  f = message.getHandshake();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake.serializeBinaryToWriter
    );
  }
};


/**
 * optional TreeChangeType change = 1;
 * @return {?proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.prototype.getChange = function() {
  return /** @type{?proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType} */ (
    jspb.Message.getWrapperField(this, scenetree_protos_domain_pb.TreeChangeType, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.prototype.setChange = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.prototype.clearChange = function() {
  return this.setChange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.prototype.hasChange = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Handshake handshake = 2;
 * @return {?proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.prototype.getHandshake = function() {
  return /** @type{?proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.prototype.setHandshake = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.prototype.clearHandshake = function() {
  return this.setHandshake(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.SubscribeResponse.prototype.hasHandshake = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Handshake.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    filter: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fullTree: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    columnsKeysList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    exactMatch: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    removeHiddenItems: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilter(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFullTree(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addColumnsKeys(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExactMatch(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRemoveHiddenItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilter();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFullTree();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getColumnsKeysList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getExactMatch();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getRemoveHiddenItems();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string filter = 1;
 * @return {string}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.prototype.getFilter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.prototype.setFilter = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool full_tree = 2;
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.prototype.getFullTree = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.prototype.setFullTree = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated string columns_keys = 3;
 * @return {!Array<string>}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.prototype.getColumnsKeysList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.prototype.setColumnsKeysList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.prototype.addColumnsKeys = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.prototype.clearColumnsKeysList = function() {
  return this.setColumnsKeysList([]);
};


/**
 * optional bool exact_match = 4;
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.prototype.getExactMatch = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.prototype.setExactMatch = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool remove_hidden_items = 5;
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.prototype.getRemoveHiddenItems = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterRequest.prototype.setRemoveHiddenItems = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    numberOfResults: jspb.Message.getFieldWithDefault(msg, 1, 0),
    indexingStatus: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumberOfResults(value);
      break;
    case 2:
      var value = /** @type {!proto.vertexvis.protobuf.scenetree.v1alpha1.IndexingStatus} */ (reader.readEnum());
      msg.setIndexingStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNumberOfResults();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getIndexingStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional uint32 number_of_results = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse.prototype.getNumberOfResults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse.prototype.setNumberOfResults = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional IndexingStatus indexing_status = 2;
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.IndexingStatus}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse.prototype.getIndexingStatus = function() {
  return /** @type {!proto.vertexvis.protobuf.scenetree.v1alpha1.IndexingStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.IndexingStatus} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterResponse.prototype.setIndexingStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    nodeId: (f = msg.getNodeId()) && core_protos_uuid_pb.Uuid.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new core_protos_uuid_pb.Uuid;
      reader.readMessage(value,core_protos_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setNodeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNodeId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid node_id = 2;
 * @return {?proto.vertexvis.protobuf.core.Uuid}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest.prototype.getNodeId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest.prototype.setNodeId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest.prototype.clearNodeId = function() {
  return this.setNodeId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemRequest.prototype.hasNodeId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    locatedIndex: (f = msg.getLocatedIndex()) && google_protobuf_wrappers_pb.UInt64Value.toObject(includeInstance, f),
    requiresReload: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.UInt64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.UInt64Value.deserializeBinaryFromReader);
      msg.setLocatedIndex(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequiresReload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocatedIndex();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.UInt64Value.serializeBinaryToWriter
    );
  }
  f = message.getRequiresReload();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional google.protobuf.UInt64Value located_index = 1;
 * @return {?proto.google.protobuf.UInt64Value}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse.prototype.getLocatedIndex = function() {
  return /** @type{?proto.google.protobuf.UInt64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.UInt64Value, 1));
};


/**
 * @param {?proto.google.protobuf.UInt64Value|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse.prototype.setLocatedIndex = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse.prototype.clearLocatedIndex = function() {
  return this.setLocatedIndex(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse.prototype.hasLocatedIndex = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool requires_reload = 2;
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse.prototype.getRequiresReload = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.LocateItemResponse.prototype.setRequiresReload = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ExpandAllResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.CollapseAllResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    nodeId: (f = msg.getNodeId()) && core_protos_uuid_pb.Uuid.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid;
      reader.readMessage(value,core_protos_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setNodeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNodeId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid node_id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest.prototype.getNodeId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest.prototype.setNodeId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest.prototype.clearNodeId = function() {
  return this.setNodeId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsRequest.prototype.hasNodeId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    scenetree_protos_domain_pb.Node.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new scenetree_protos_domain_pb.Node;
      reader.readMessage(value,scenetree_protos_domain_pb.Node.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      scenetree_protos_domain_pb.Node.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Node items = 1;
 * @return {!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Node>}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Node>} */ (
    jspb.Message.getRepeatedWrapperField(this, scenetree_protos_domain_pb.Node, 1));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Node>} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vertexvis.protobuf.scenetree.v1alpha1.Node, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetNodeAncestorsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    keysList: jspb.Message.toObjectList(msg.getKeysList(),
    scenetree_protos_domain_pb.ColumnKey.toObject, includeInstance),
    indexingStatus: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new scenetree_protos_domain_pb.ColumnKey;
      reader.readMessage(value,scenetree_protos_domain_pb.ColumnKey.deserializeBinaryFromReader);
      msg.addKeys(value);
      break;
    case 2:
      var value = /** @type {!proto.vertexvis.protobuf.scenetree.v1alpha1.IndexingStatus} */ (reader.readEnum());
      msg.setIndexingStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKeysList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      scenetree_protos_domain_pb.ColumnKey.serializeBinaryToWriter
    );
  }
  f = message.getIndexingStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * repeated ColumnKey keys = 1;
 * @return {!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey>}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.prototype.getKeysList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey>} */ (
    jspb.Message.getRepeatedWrapperField(this, scenetree_protos_domain_pb.ColumnKey, 1));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey>} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.prototype.setKeysList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.prototype.addKeys = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.prototype.clearKeysList = function() {
  return this.setKeysList([]);
};


/**
 * optional IndexingStatus indexing_status = 2;
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.IndexingStatus}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.prototype.getIndexingStatus = function() {
  return /** @type {!proto.vertexvis.protobuf.scenetree.v1alpha1.IndexingStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.IndexingStatus} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.GetAvailableColumnsResponse.prototype.setIndexingStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


goog.object.extend(exports, proto.vertexvis.protobuf.scenetree.v1alpha1);
